module.exports = __webpack_public_path__ + "img/cr1_1.40bb203b.png";